import { styled } from '@mui/material'

export const ChartLegendIcon = styled('i')(({ color }) => ({
  width: '10px',
  height: '10px',
  backgroundColor: color,
  marginRight: '5px',
  marginTop: '4px',
  display: 'inline-block',
}))
